<template>
    <a-steps style="width: 330px">
        <a-step v-if="step < 3" status="progress" title="课件生成">
            <template #icon>
                <LoadingOutlined />
            </template>
        </a-step>
        <a-step v-else status="finish" title="课件生成">
            <template #icon>
                <FilePptOutlined />
            </template>
        </a-step>
        <a-step v-if="step === 3" status="process" title="视频制作">
            <template #icon>
                <LoadingOutlined />
            </template>
        </a-step>
        <a-step v-else status="wait" title="视频制作">
            <template #icon>
                <VideoCameraOutlined />
            </template>
        </a-step>
    </a-steps>
</template>
<script>
    import { defineComponent } from 'vue';
    import {
        LoadingOutlined,
        FilePptOutlined,
        VideoCameraOutlined,
    } from '@ant-design/icons-vue';

    export default defineComponent({
        name: "PaperVideoSteps",
        props: ['step'],
        components: {
            LoadingOutlined,
            VideoCameraOutlined,
            FilePptOutlined
        },
    });
</script>